import Vue from 'vue';

// Basic UI
import Alert from '@/components/common/alert.vue';
import JbEditor from '@/components/common/jb-editor.vue';
import JbActiveChip from '@/components/common/jb-active-chip.vue';
import EmptyGrid from '@/components/empty/empty-grid.vue';
import EmptyTableRow from '@/components/empty/empty-table-row.vue';
import PaginationCenter from '@/components/common/pagination-center.vue';
import SearchBar from '@/components/common/search-bar.vue';
import Badge from '@/components/badge/badge.vue';
import Notification from '@/components/notification/notification.vue';
import ListGridToggle from '@/components/common/list-grid-toggle.vue';

Vue.component('notification', Notification);
Vue.component('badge', Badge);
Vue.component('alert', Alert);
Vue.component('jb-active-chip', JbActiveChip);
Vue.component('jb-editor', JbEditor);
Vue.component('empty-grid', EmptyGrid);
Vue.component('empty-table-row', EmptyTableRow);
Vue.component('pagination-center', PaginationCenter);
Vue.component('search-bar', SearchBar);
Vue.component('list-grid-toggle', ListGridToggle);

// Tile: Used in listing items
import TileContainer from '@/components/tile/tile-container.vue';
import TileHead from '@/components/tile/tile-head.vue';
import TileRow from '@/components/tile/tile-row.vue';
import TileAvatar from '@/components/tile/tile-avatar.vue';
import TileWrapper from '@/components/tile/tile-wrapper.vue';
import TileListUsers from '@/components/tile/tile-list-users.vue';

Vue.component('tile-wrapper', TileWrapper);
Vue.component('tile-container', TileContainer);
Vue.component('tile-head', TileHead);
Vue.component('tile-row', TileRow);
Vue.component('tile-avatar', TileAvatar);
Vue.component('tile-list-users', TileListUsers);

// Form Elements: Borrowed and modified from Basic UIs
import FormAsyncselect from '@/components/form/FormAsyncselect.vue';

Vue.component('form-asyncselect', FormAsyncselect);

// Table Elements : Use for alternate view instead of Tiles
import TableStatus from '@/components/table/table-status.vue';
import TableBadge from '@/components/table/table-badge.vue';
import TableButton from '@/components/table/table-button.vue';
import TableButtons from '@/components/table/table-buttons.vue';
import TableSingleChip from '@/components/table/table-single-chip.vue';
import TableHeader from '@/components/table/table-header.vue';
import TableAvatar from '@/components/table/TableAvatar.vue';
import TableListUser from '@/components/table/table-list-user.vue';
import TableListChip from '@/components/table/table-list-chip.vue';
import TableIcon from '@/components/table/table-icon.vue';
import TableRow from '@/components/table/table-row.vue';
import TableText from '@/components/table/table-text.vue';
import TableChips from '@/components/table/table-chips.vue';
import TableRowDropdown from '@/components/table/table-row-dropdown.vue';
import TableWrapper from '@/components/table/table-wrapper.vue';
import TablePagination from '@/components/table/table-pagination.vue';
import TableContainer from '@/components/table/table-container.vue';

Vue.component('table-pagination', TablePagination);
Vue.component('table-row', TableRow);
Vue.component('table-wrapper', TableWrapper);
Vue.component('table-chips', TableChips);
Vue.component('table-text', TableText);
Vue.component('table-row-dropdown', TableRowDropdown);
Vue.component('table-status', TableStatus);
Vue.component('table-button', TableButton);
Vue.component('table-buttons', TableButtons);
Vue.component('table-single-chip', TableSingleChip);
Vue.component('table-header', TableHeader);
Vue.component('table-badge', TableBadge);
Vue.component('table-avatar', TableAvatar);
Vue.component('table-list-user', TableListUser);
Vue.component('table-list-chip', TableListChip);
Vue.component('table-icon', TableIcon);
Vue.component('table-container', TableContainer);

import ContactCard from '@/components/contact-card/contact-card.vue';
Vue.component('contact-card', ContactCard);

// Page: Use in pages, either head or layout purpose
import PageSectionHeading from '@/components/page/page-section-heading.vue';
import PageHeadContainer from '@/components/page/PageHeadContainer.vue';
import PageHeadIcon from '@/components/page/PageHeadIcon.vue';
import PageHeadAvatar from '@/components/page/page-head-avatar.vue';
import PageHeadListToggle from '@/components/page/page-head-list-toggle.vue';
import PageToolbar from '@/components/page/page-toolbar.vue';
import PageSubToolbar from '@/components/page/page-sub-toolbar.vue';
import PageWrapper from '@/components/page/page-wrapper.vue';
import PageFooter from '@/components/page/page-footer.vue';
Vue.component('section-heading', PageSectionHeading);
Vue.component('page-wrapper', PageWrapper);
Vue.component('page-footer', PageFooter);
Vue.component('page-head-container', PageHeadContainer);
Vue.component('page-head-icon', PageHeadIcon);
Vue.component('page-head-avatar', PageHeadAvatar);
Vue.component('page-head-list-toggle', PageHeadListToggle);
Vue.component('page-toolbar', PageToolbar);
Vue.component('page-sub-toolbar', PageSubToolbar);

// List
import ListWrapper from '@/components/list/list-wrapper.vue';

Vue.component('list-wrapper', ListWrapper);

// Card
import CardGrid from '@/components/legacy/card/card-grid.vue';
import CardChips from '@/components/legacy/card/card-chips.vue';
import CardHead from '@/components/legacy/card/card-head.vue';
import CardHeading from '@/components/legacy/card/card-heading.vue';
import CardRow from '@/components/legacy/card/card-row.vue';
import CardRowEntry from '@/components/legacy/card/card-row-entry.vue';

Vue.component('card-grid', CardGrid);
Vue.component('card-heading', CardHeading);
Vue.component('card-head', CardHead);
Vue.component('card-row', CardRow);
Vue.component('card-row-entry', CardRowEntry);
Vue.component('card-chips', CardChips);

// Descriptions
import DescriptionContainer from '@/components/description/description-container.vue';
import DescriptionSummary from '@/components/description/description-summary.vue';
import DescriptionListing from '@/components/description/description-listing.vue';
import DescriptionHeading from '@/components/description/description-heading.vue';

Vue.component('description-container', DescriptionContainer);
Vue.component('description-summary', DescriptionSummary);
Vue.component('description-listing', DescriptionListing);
Vue.component('description-heading', DescriptionHeading);

// 3rd Party
import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);

import vSelect from 'vue-select';

Vue.component('v-select', vSelect);
